export const SETTINGS_TOGGLE = '[Core]/SETTINGS_TOGGLE';
export const DARK_MODE_TOGGLE = '[Core]/DARK_MODE_TOGGLE';
